import { render } from "./GenericAlert.vue?vue&type=template&id=5277872b"
import script from "./GenericAlert.vue?vue&type=script&lang=js"
export * from "./GenericAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__